import React, { useEffect, useState } from 'react';
import { Check, Package, Loader2, AlertCircle, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { API } from '../config';
import axios from 'axios';

const PackageConfirmed = () => {
  const [status, setStatus] = useState('checking');
  const [purchase, setPurchase] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const purchaseId = params.get('purchase_id');
    if (!purchaseId) {
      setStatus('error');
      return;
    }

    const checkStatus = async () => {
      try {
        const res = await axios.get(`${API}/packages/purchase/${purchaseId}/status`);
        setPurchase(res.data);
        setStatus(res.data.payment_status === 'paid' ? 'paid' : 'pending');
      } catch {
        setStatus('error');
      }
    };

    checkStatus();
    const interval = setInterval(checkStatus, 3000);
    const timeout = setTimeout(() => clearInterval(interval), 30000);
    return () => { clearInterval(interval); clearTimeout(timeout); };
  }, []);

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 text-center" data-testid="package-confirmed-page">
        {status === 'checking' && (
          <>
            <Loader2 size={48} className="animate-spin text-luxury-green mx-auto mb-6" />
            <h1 className="font-display text-2xl text-luxury-green mb-2">Verifying Payment</h1>
            <p className="text-stone-500">Please wait while we confirm your purchase...</p>
          </>
        )}

        {status === 'paid' && (
          <>
            <div className="w-20 h-20 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Check size={36} className="text-luxury-green" />
            </div>
            <h1 className="font-display text-2xl text-luxury-green mb-2">Purchase Confirmed!</h1>
            <p className="text-stone-500 mb-6">
              Thank you, {purchase?.buyer_name}! Your package is now active.
            </p>
            <div className="bg-stone-50 rounded-xl p-5 mb-6 text-left">
              <div className="flex items-center gap-3 mb-3">
                <Package size={20} className="text-luxury-green" />
                <span className="font-semibold text-stone-800">{purchase?.package_name}</span>
              </div>
              <p className="text-sm text-stone-500">
                We've sent your package details to your email. You can now book your sessions through our website or by calling us.
              </p>
            </div>
            <Button
              onClick={() => window.location.href = '/'}
              className="w-full bg-luxury-green hover:bg-luxury-green/90 text-white rounded-full py-5"
            >
              <ArrowLeft size={16} className="mr-2" />
              Back to Home
            </Button>
          </>
        )}

        {status === 'pending' && (
          <>
            <Loader2 size={48} className="animate-spin text-amber-500 mx-auto mb-6" />
            <h1 className="font-display text-2xl text-stone-800 mb-2">Payment Processing</h1>
            <p className="text-stone-500 mb-6">
              Your payment is being processed. This page will update automatically.
            </p>
            <Button
              onClick={() => window.location.href = '/'}
              variant="outline"
              className="rounded-full"
            >
              Return Home
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <AlertCircle size={48} className="text-red-400 mx-auto mb-6" />
            <h1 className="font-display text-2xl text-stone-800 mb-2">Something Went Wrong</h1>
            <p className="text-stone-500 mb-6">
              We couldn't verify your purchase. Please contact us if payment was taken.
            </p>
            <div className="flex gap-3">
              <Button
                onClick={() => window.open('https://wa.me/353857747474', '_blank')}
                className="flex-1 bg-luxury-green-600 hover:bg-luxury-green-500 text-white rounded-full"
              >
                Contact Us
              </Button>
              <Button
                onClick={() => window.location.href = '/'}
                variant="outline"
                className="flex-1 rounded-full"
              >
                Home
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PackageConfirmed;
